<div class="zn-step-content-sections">
  <div class="zn-step-content-section zn-step-content-section--selected">
    <div class="zn-step-content-section-header">
      <div class="zn-step-content-section-header-inner-container">
        <div class="zn-step-content-section-titles">
          <h5>{{ (localizationKeyPrefix + '.Search.Title') | abpLocalization }}</h5>
          <p>{{ (localizationKeyPrefix + '.Search.Description') | abpLocalization }}</p>
        </div>
      </div>
      <hr class="zn-separator" />
    </div>
    <div class="zn-step-content-section-body">
      <div class="zn-step-content-section-layout">
        <div class="zn-step-content-section-filters">
          <div class="form-control-container">
            <label class="form-label" for="standFusionEstablishmentSelect">
              {{ 'Geographic::Entity.ForestryBase.PropertyName' | abpLocalization }}
              <span class="form-label-required">*</span>
            </label>
            <zn-single-select
              #establishmentSelect
              id="standFusionEstablishmentSelect"
              [options]="selectedEstablishmentOptions()"
              [optionsLoader]="establishmentOptionsLoader"
              [showSearch]="true"
              [localizationResource]="localizationResource"
              [openUp]="false"
              (selectedChange)="onEstablishmentChange($event)"
            ></zn-single-select>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
